module.exports = __webpack_public_path__ + "images/emoji/speedboat.d877df86b5832138adf4.png";